import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import Minecraft from "./components/minecraft/Minecraft"
import Terminal from "./components/terminal/Terminal";
import {Four0Four} from "./components/Four0Four";
import Folio from "./components/folio/Folio";

export default function App() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<div>Home</div>}/>
                <Route path="/terminal" element={<Terminal/>}/>
                <Route path="/minecraft" element={<Minecraft/>}/>
                <Route path="/folio" element={<Folio/>}/>
                <Route path="*" element={<Four0Four/>}/>
            </Routes>
        </Router>
    )
}
